// extracted by css-extract-rspack-plugin
export default {"label":"label-BnDPlZ","input":"input-KTf7dZ"};